import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import Card from './form/Card.js';
import SplitRows from '../../components/general/SplitRow.js';
import OptionColumn from '../../components/general/OptionColumn.js';
import Notification from '../../components/Notification.js'
import moment from 'moment';
import LoadingSmall from '../../components/LoadingSmall.js';
import GeneralHandler from '../../modules/General';

class BillingInvoices extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            'isLoading':true,
            'accept_cancel':false,
            'isCancelling':false,
            'isResuming':false,
            'next_billing_period':false,
            'invoices':[],
            'refunds':[],

        }


    }

    componentWillMount() {
        GeneralHandler.fetchGeneral().then(() => {
            axios.get('/invoices').then(res => {
                if(this.props.general.account.dealer && res.data.invoices.length == 0) {
                    this.props.router.push(GeneralHandler.Link('/settings/billing/dealer'));
                    return;
                }

                this.setState({next_billing_period:res.data.next_billing_period,refunds:res.data.refunds,invoices:res.data.invoices,isLoading:false});
            }).catch(res => {
                this.setState({isLoading:false});
            });

        });
    }


    render() {

        if(this.state.isLoading) {
            return <Loading error={false} />
        }

        return (

            <div className="full-height">
                <div className="page-header">
                    <span className="page-title"><i className="icon wb-order"></i> Invoices</span>
                </div>

                <div className="page-content">

                    <OptionColumn title="Invoices" description="List of all invoices for this account.">
                        {
                            this.state.invoices.length > 0 ? <table className="table table-bordered">
                                <thead>
                                <tr className="table-active">
                                    <th>Receipt number</th>
                                    <th>Date</th>
                                    <th>Sum</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.state.invoices.map((invoice,i) => {
                                    return (
                                        <tr key={i}>
                                            <td>#{invoice.receipt_number}</td>
                                            <td>{invoice.date}</td>
                                            <td>{invoice.total}</td>
                                            <td><a href={invoice.url} target="_blank" style={{textDecoration:'none'}} className="btn btn-dark btn-md">Open</a></td>
                                        </tr>
                                    )
                                })}
                                </tbody>
                            </table>
                                :
                                <div className="alert dark alert-icon alert-info alert-dismissible" role="alert">
                                    <i className="icon wb-info" aria-hidden="true"></i> We didn't find any previous invoices.
                                </div>
                        }
                    </OptionColumn>

                    <SplitRows/>

                    <OptionColumn title="Credit notes" description="List of all credited invoices.">
                        {
                            this.state.refunds.length > 0 ? <table className="table table-bordered">
                                    <thead>
                                    <tr className="table-active">
                                        <th>Receipt number</th>
                                        <th>Date</th>
                                        <th>Sum</th>
                                        <th></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.refunds.map((invoice,i) => {
                                        return (
                                            <tr key={i}>
                                                <td>#{invoice.receipt_number}</td>
                                                <td>{invoice.date}</td>
                                                <td>-{invoice.total}</td>
                                                <td><a href={invoice.url} target="_blank" style={{textDecoration:'none'}} className="btn btn-dark btn-md">Open</a></td>
                                            </tr>
                                        )
                                    })}
                                    </tbody>
                                </table>
                                :
                                <div className="alert dark alert-icon alert-info alert-dismissible" role="alert">
                                    <i className="icon wb-info" aria-hidden="true"></i> You don't have any credited invoices.
                                </div>
                        }
                    </OptionColumn>



                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth:state.auth,
        general:state.general,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({},dispatch)
}


BillingInvoices = connect(mapStateToProps,mapDispatchToProps)(BillingInvoices);
export default BillingInvoices;



// WEBPACK FOOTER //
// ./containers/settings/BillingInvoices.js